import { EnvironmentTypes, getEnvironment, getRegionFromHost, getServiceBaseURL, isCSR, } from '@raisin/cp-utils';
const config = {
    pia: {
        development: 'https://api2.dev-weltsparen.de/pia/api/v2',
        staging: 'https://api2.staging-weltsparen.de/pia/api/v2',
        onboarding: 'https://api2.onboarding-weltsparen.de/pia/api/v2',
        production: 'https://api2.weltsparen.de/pia/api/v2',
    },
    pom: {
        development: 'https://api2.dev-weltsparen.de/pom/api/v1',
        staging: 'https://api2.staging-weltsparen.de/pom/api/v1',
        onboarding: 'https://api2.onboarding-weltsparen.de/pom/api/v1',
        production: 'https://api2.weltsparen.de/pom/api/v1',
    },
    dbs: {
        DEU: {
            development: 'https://api2.dev-weltsparen.de/dbs/v1',
            staging: 'https://api2.staging-weltsparen.de/dbs/v1',
            onboarding: 'https://api2.onboarding-weltsparen.de/dbs/v1',
            production: 'https://api2.weltsparen.de/dbs/v1',
        },
        GBR: {
            development: 'https://api2.dev-raisin.co.uk/dbs/v1',
            onboarding: 'https://api2.onboarding-raisin.co.uk/dbs/v1',
            production: 'https://api2.raisin.co.uk/dbs/v1',
            staging: 'https://api2.staging-raisin.co.uk/dbs/v1',
        },
    },
};
export const getBaseUrlForPia = () => {
    const namespace = getEnvironment();
    return config['pia'][namespace];
};
export const getBaseUrlForPom = () => {
    const namespace = getEnvironment();
    return config['pom'][namespace];
};
export const getBaseUrlForDbs = () => {
    var _a, _b;
    const environment = getEnvironment();
    const region = getRegionFromHost();
    return isCSR() ? (_b = (_a = config === null || config === void 0 ? void 0 : config['dbs']) === null || _a === void 0 ? void 0 : _a[region]) === null || _b === void 0 ? void 0 : _b[environment] : '';
};
export const integrationSerApiBaseUrl = (version = 'v1') => {
    if (isCSR()) {
        return getEnvironment() === EnvironmentTypes.LOCAL
            ? `https://api.dev-raisin.com/wjis/${version}`
            : getServiceBaseURL('wjis', undefined, version);
    }
    return '';
};
//# sourceMappingURL=index.js.map